import Controler from '../base/Controler';
import Dropdown from './Dropdown';

class DropdownControler extends Controler {
  constructor() {
    super();
    this.initClickableDropdowns();
  }

  private initClickableDropdowns(): Dropdown[] {
    const dropdownsArr: Dropdown[] = [];
    const els = this.selectElements('.js-clickable-dropdown');

    els.forEach(el => {
      const dropdown = new Dropdown(el);
      dropdownsArr.push(dropdown);
    });

    return dropdownsArr;
  }
}

export default DropdownControler;
